import {
  SidePanel,
  ButtonPrimary,
  ButtonSecondary,
  IconLoader,
  PermissionEnum,
} from '@ui/src';
import AccountForm from '../../../components/charts/charts-panel/charts-panel-account';
import usePrimaryAccountEdit from './hooks/use-edit';

import cn from '../styles.module.css';

const PrimaryAccountEdit = (): React.JSX.Element => {
  const {
    typeOptions,
    activePermissions,
    globalError,
    primaryAccountId,
    categoryId,
    groupId,
    isLoading,
    isFetching,
    control,
    errors,
    description,
    requestInProgress,
    onSubmit,
    handleClose,
    panelIsOpen,
    categories,
    groups,
    selectedPrimaryAccount,
  } = usePrimaryAccountEdit();

  let content;

  if (isLoading || isFetching) {
    content = (
      <div className={cn.selectedCategoryLoading}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <AccountForm
        category={categories.find((category) => category.id === categoryId)}
        name={description}
        control={control}
        group={groups?.find((group) => group.id === groupId)}
        typeOptions={typeOptions}
        errors={errors}
        accountNumber={selectedPrimaryAccount?.number}
        primaryId={primaryAccountId}
        isEditable={activePermissions?.includes(
          PermissionEnum.ACCOUNTS_CHART_EDIT_PRIMARY_ACTION,
        )}
      />
    );
  }

  return (
    <SidePanel
      closeOnClickOutside={false}
      isOpen={panelIsOpen}
      onClose={handleClose}
      title={`Account ${
        activePermissions?.includes(
          PermissionEnum.ACCOUNTS_CHART_EDIT_PRIMARY_ACTION,
        )
          ? 'Edit'
          : 'Info'
      }`}
      className={cn.chartSidePanel}
      sidepanelExpandedKey="charts-account-edit"
      errorSidepanel={globalError}
      withoutExpand
      parent={document.getElementById('chart-modal') as HTMLElement}
      footer={
        <>
          {activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_EDIT_PRIMARY_ACTION,
          ) && (
            <ButtonPrimary
              text={requestInProgress ? 'Loading...' : 'Save'}
              disabled={requestInProgress}
              onClick={onSubmit}
            />
          )}
          <ButtonSecondary text="Close" onClick={handleClose} />
        </>
      }
    >
      {content}
    </SidePanel>
  );
};

export default PrimaryAccountEdit;
